import { render, staticRenderFns } from "./ModalDeleteTeam.vue?vue&type=template&id=71757e79"
import script from "./ModalDeleteTeam.vue?vue&type=script&lang=js"
export * from "./ModalDeleteTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports